module.exports = __webpack_public_path__ + "media/mosaics/Mosaic-Testimonial-c05158bc.png";